import { call, put, takeEvery } from "redux-saga/effects";

import {
  LENGS_LIST,
  LENGS_FILTER,
  LENGS_CREATE,
  LENGS_UPDATE,
} from "./actionTypes";

import {
 lengsListSuccess,
 lengsCreateSuccess,
 lengsUpdateSuccess,
 lengsRequestFailed,
} from "./actions";

import {
  getLengsList,
  getLengsFilter,
  postLengsCreate,
  patchLengsUpdate,
} from "../../helpers/backend";

function*lengsListSaga() {
  console.log("Trayendo lista de lengs...");
  try {
    const response = yield call(getLengsList);
    if (response.status === 200) {
      yield put(lengsListSuccess(response.data));
    } else {
      yield put(lengsRequestFailed(response.data));
    }
  } catch (error) {
    yield put(lengsRequestFailed(error.response.data));
  }
}

function*lengsCreateSaga({ payload:lengs }) {
  console.log("Creando nuevo lengs...");
  try {
    const response = yield call(postLengsCreate,lengs);
    if (response.status === 201) {
      yield put(lengsCreateSuccess(response.data));
    } else {
      yield put(lengsRequestFailed(response.data));
    }
  } catch (error) {
    yield put(lengsRequestFailed(error.response.data));
  }
}

function*lengsFilterSaga({ payload: { changeUrl } }) {
  try {
    const response = yield call(getLengsFilter, { changeUrl });
    if (response.status === 200) {
      yield put(lengsListSuccess(response.data));
    } else {
      yield put(lengsRequestFailed(response.data));
    }
  } catch (error) {
    yield put(lengsRequestFailed(error.response.data));
  }
}

function*lengsUpdateSaga({ payload: { id, data } }) {
  console.log("Actualizando datos del lengs...");
  try {
    const response = yield call(patchLengsUpdate, { id }, data);
    if (response.status === 200) {
      yield put(lengsUpdateSuccess(response.data));
    } else {
      yield put(lengsRequestFailed(response.data));
    }
  } catch (error) {
    yield put(lengsRequestFailed(error.response.data));
  }
}

export default function*lengsSaga() {
  yield takeEvery(LENGS_LIST,lengsListSaga);
  yield takeEvery(LENGS_FILTER,lengsFilterSaga);
  yield takeEvery(LENGS_CREATE,lengsCreateSaga);
  yield takeEvery(LENGS_UPDATE,lengsUpdateSaga);
}
